var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNatinality({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.207006 0.90747C0.141694 0.961907 0.0893842 1.02927 0.053657 1.10495C0.0179299 1.18063 -0.000371384 1.26283 5.71115e-06 1.34594V9.42306C5.71115e-06 9.57608 0.0632198 9.72282 0.175742 9.83102C0.288263 9.93922 0.440876 10 0.600005 10C0.759135 10 0.911748 9.93922 1.02427 9.83102C1.13679 9.72282 1.20001 9.57608 1.20001 9.42306V7.39032C2.342 6.56722 3.305 6.95185 4.734 7.63071C5.5455 8.01534 6.471 8.45765 7.474 8.45765C8.21 8.45765 8.988 8.22015 9.793 7.54994C9.8578 7.49593 9.90981 7.42919 9.94552 7.35421C9.98122 7.27924 9.9998 7.19778 10 7.11531V1.34594C10 1.23532 9.96697 1.12703 9.90479 1.03396C9.8426 0.940894 9.7539 0.86698 9.64925 0.821026C9.54461 0.775072 9.42843 0.759014 9.31456 0.774767C9.20069 0.790519 9.09393 0.837417 9.007 0.909874C7.7715 1.93923 6.7805 1.54979 5.266 0.829103C3.8595 0.156971 2.1085 -0.676223 0.207006 0.90747ZM8.8 6.83935C7.658 7.66292 6.695 7.27734 5.266 6.59896C4.108 6.04606 2.7165 5.3845 1.20001 6.05135V1.61951C2.342 0.796409 3.305 1.18103 4.734 1.8599C5.5455 2.24452 6.471 2.68684 7.474 2.68684C7.93186 2.6875 8.38437 2.59218 8.8 2.40751V6.83935Z",
    fill: "#424444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNatinality);
export default __webpack_public_path__ + "static/media/natinality.929dd562e0f1887288d79bf0a7a8be3f.svg";
export { ForwardRef as ReactComponent };